import React from 'react';
import PropTypes from 'prop-types';
import './PhoneInventoryFilter.css';

export class PhoneInventoryFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: props.filter || '',
      filterValid: true,
      assignmentStatus: 'all',
      numberType: 'all',
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmitFilter('q', this.state.filter);
  };

  statusChange = (e) => {
    this.setState({
      assignmentStatus: e.target.value
    });
    this.props.onSubmitFilter('assignment_status', e.target.value);
  };

  typeChange = (e) => {
    this.setState({
      numberType: e.target.value
    });
    this.props.onSubmitFilter('number_type', e.target.value);
  };

  render() {
    const { filter } = this.state;

    return (
      <div className="phone-inventory-filter">
        {/* Search Input */}
        <div className="filter-search">
          <form onSubmit={this.handleSubmit}>
            <div className="search-input-wrapper">
              <i className="la la-search search-icon"></i>
              <input
                type="text"
                className="search-input"
                placeholder="Search numbers..."
                value={filter}
                onChange={(e) => this.setState({ filter: e.target.value })}
              />
              {/* <span className="search-shortcut">/</span> */}
            </div>
          </form>
        </div>

        {/* Phone Number Type Filter */}
        <div className="filter-dropdown">
          <select
            className="filter-select"
            value={this.state.numberType}
            onChange={(e) => this.typeChange(e)}
          >
            <option value="all">All Types</option>
            <option value="outbound">Outbound</option>
            <option value="voip">VoIP</option>
          </select>
          <i className="la la-angle-down dropdown-icon"></i>
        </div>

        {/* Assignment Status Filter */}
        <div className="filter-dropdown">
          <select
            className="filter-select"
            value={this.state.assignmentStatus}
            onChange={(e) => this.statusChange(e)}
          >
            <option value="all">All Status</option>
            <option value="business_profile">Business Profile</option>
            <option value="sms_campaign">SMS Campaign</option>
            <option value="both">Business + SMS</option>
            <option value="not_assigned">Not Assigned</option>
          </select>
          <i className="la la-angle-down dropdown-icon"></i>
        </div>

        {/* Assign Number Button */}
        {this.props.onAssignNumber && (
          <button
            className="btn-assign-number"
            onClick={this.props.onAssignNumber}
          >
            <i className="la la-plus"></i>
            Assign Number
          </button>
        )}
      </div>
    );
  }
}

PhoneInventoryFilter.propTypes = {
  onSubmitFilter: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  totalCount: PropTypes.number,
  onAssignNumber: PropTypes.func,
};
